import { convert } from './convert.js';
const splitExpression = /(-?(?:\d+)?\.?\d+)(\S+)/g;
function to(unit, kind) {
    const isBest = unit === 'best';
    let result = 0;
    let resolvedUnit;
    let isFirstPass = true;
    do {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const converted = convert(Number(this._search[1 /* MatchGroup.Quantity */]), this._search[2 /* MatchGroup.Unit */]).to(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        isBest && !isFirstPass ? resolvedUnit : unit);
        if (isBest && isFirstPass) {
            result += converted.quantity;
            resolvedUnit = converted.unit;
            isFirstPass = false;
        }
        else {
            result += converted;
        }
        this._search = splitExpression.exec(this._value);
    } while (this._search);
    if (isBest) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        return convert(result, resolvedUnit).to('best', kind);
    }
    return result;
}
/**
 * Convert several values in a string into a single unit.
 *
 * @example
 * ```ts
 * convertMany('1d 12h').to('hours') === 36;
 * ```
 *
 * @param value - The string to parse as values
 *
 * @public
 */
export function convertMany(value) {
    splitExpression.lastIndex = 0;
    const search = splitExpression.exec(value);
    if (!search) {
        if (__DEV__) {
            throw new RangeError(`value did not match expression ${splitExpression.source}`);
        }
        throw new RangeError();
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        to: to.bind({
            _search: search,
            _value: value,
        }),
    };
}
//# sourceMappingURL=convert-many.js.map